export const validationErrorsStyle = (components, theme) => ({
  '& ul[role=alert], & .font-error > ul': {
    listStyle: 'none',
    paddingLeft: 0,
  },
  '& span.is-error, & .font-error': {
    color: `${theme.semanticColors && theme.semanticColors.errorIcon}`,
  },
});
